export default __webpack_public_path__ + "static/media/neerlandia-urk.c3524df1.png";